import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI, settingsAPI } from '@/lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [settings, setSettings] = useState({ tourenplanung_enabled: true });
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('wunddok_token');
    const savedUser = localStorage.getItem('wunddok_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
        loadSettings();
      } catch { /* ignore */ }
    }
    setLoading(false);
  }, []);

  const loadSettings = async () => {
    try {
      const res = await settingsAPI.get();
      setSettings(res.data);
    } catch { /* use defaults */ }
  };

  const login = async (email, password) => {
    const res = await authAPI.login({ email, password });
    localStorage.setItem('wunddok_token', res.data.token);
    localStorage.setItem('wunddok_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    loadSettings();
    return res.data;
  };

  const register = async (name, email, password) => {
    const res = await authAPI.register({ name, email, password });
    localStorage.setItem('wunddok_token', res.data.token);
    localStorage.setItem('wunddok_user', JSON.stringify(res.data.user));
    setUser(res.data.user);
    loadSettings();
    return res.data;
  };

  const logout = () => {
    localStorage.removeItem('wunddok_token');
    localStorage.removeItem('wunddok_user');
    setUser(null);
  };

  const isAdmin = user?.role === 'admin';
  const isHauptmitarbeiter = user?.role === 'hauptmitarbeiter';
  const canAccessTourenplanung = settings.tourenplanung_enabled || isAdmin;
  const canArchive = isAdmin || isHauptmitarbeiter;
  const canDelete = isAdmin;

  return (
    <AuthContext.Provider value={{ user, loading, settings, login, register, logout, loadSettings, isAdmin, isHauptmitarbeiter, canAccessTourenplanung, canArchive, canDelete }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
